import React from 'react';
import {TextInput, Create, SimpleForm, required, ImageInput, ImageField} from 'react-admin';
import {makeStyles, Theme} from '@material-ui/core';
import BaseListActions from '../BaseListActions';
import {HASHTAG_CATEGORY} from '../../consts/Names';
import {Validators} from '../../consts/Validators';
import {Messages} from '../../consts/Messages';

const useStyles = makeStyles((theme: Theme) => ({
   formContainer: {
      width: '80%',
      padding: '0 1em 1em 1em'
   },
   textFld: {
      width: '300px',
      marginTop: '1em'
   },
   imageFld: {
      display: 'flex',
      width: '300px'
   }
}));

const validateStock = [required(), Validators.minValue(3, Messages.MIN_VALUE)];

export const HashTagCategoriesCreate = (props) => {
   const {theme, basePath} = props;
   const classes = useStyles(theme);

   return (
      <Create {...props} actions={<BaseListActions basePath={basePath} />} title="Create category for hashtags">
         <SimpleForm className={classes.formContainer} redirect="list">
            <TextInput className={classes.textFld} label="Category Name" source={HASHTAG_CATEGORY.name} validate={validateStock} />
            <ImageInput className={classes.imageFld} source="image" label="Related picture" accept="image/*" validate={required()} placeholder={<p>Drop your image here</p>}>
                <ImageField source={'image'} title="title" />
             </ImageInput>
         </SimpleForm>
      </Create>
   );
};
